<template>
  <div class="esport-section">
    <button @click="navigateToMainPage" class="back-button back-button--img" aria-label="Retour">
      <img src="@/assets/bouton-retour.png" alt="Retour" class="back-button__img" />
      <span class="visually-hidden">Retour</span>
    </button>
    <div class="esport-logos-bottom">
      <img
        v-for="jeu in jeux"
        :key="jeu.nom"
        :src="require(`@/assets/logo_jeux/${jeu.logo}`)"
        :alt="jeu.nom"
        class="esport-logo"
        @click="onLogoClick(jeu)"
      />
    </div>

    <!-- Fenêtre modale -->
    <div
      v-if="jeuSelectionne"
      class="esport-modal"
      @click.self="fermerFenetre"
    >
      <div class="esport-modal-content">
        <!-- Header avec titre et bouton de fermeture -->
        <div class="esport-modal-header">
          <h2 class="esport-modal-title">{{ jeuSelectionne }}</h2>
          <button class="modal-close-btn" @click="fermerFenetre">✕</button>
        </div>

        <!-- League of Legends : image + texte + zone bas -->
        <div v-if="jeuSelectionne === 'League of Legends'">
          <div class="lol-modal-flex">
            <img
              :src="require('@/assets/LFT_cv.png')"
              alt="LFT CV"
              class="lol-modal-img"
            />
            <div class="lol-modal-texte">
              <span v-html="jeux.find(j => j.nom === jeuSelectionne)?.description"></span>
            </div>
          </div>
          <div class="lol-modal-bottom">
          </div>
        </div>

        <!-- Autres jeux : juste une grande zone de texte -->
        <div v-else class="othergame-modal-text">
          <span v-html="jeux.find(j => j.nom === jeuSelectionne)?.description"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EsportPage',
  data() {
    return {
      jeux: [
        {
          nom: 'League of Legends',
          logo: 'LoL_logo.png',
          description: "League of Legends est un MOBA compétitif où j'ai managé et coaché plusieurs équipes, participé à des LAN et développé des stratégies d'équipe."
          + "<br><br>L'image à gauche est comme un CV pour mes activités sur LoL. Il permet de facilement comprendre quel joueur je suis et quelles sont mes compétences et expériences."
          + "<br><br>League of legends a été un pilier de mon parcours e-sportif, où j'ai non seulement joué à un niveau compétitif élevé, mais aussi géré et coaché des équipes."
          + " J'ai participé à de nombreuses LANs et développé des stratégies d'équipe qui m'ont permis de comprendre en profondeur le jeu et ses mécaniques."
          + "<br><br>Au meilleur de ma carrière, j'ai atteint le rang Master+, c'est d'abord un engagement mais aussi un certain exploit"
          + " puisque cela m'a permis de me hisser dans le top 0.05% des joueurs classés."
          + "<br>Autrement dit, je jouais parmis les 2000 meilleurs joueurs d'Europe sur environ 4 millions de joueurs en mode compétitif."
        },
        {
          nom: 'Rocket League',
          logo: 'RL_logo.png',
          description: "Rocket League m'a permis d'évoluer en tant que joueur à haut niveau, avec une expérience en management d'équipe et en organisation de tournois."
          + "<br><br>Avec la même équipe nous avons pu grandir ensemble et en fin de parcours, atteindre des matchs de niveau SSL ce qui nous permettait également de gagner certains tournois rémunérants."
          + "<br><br>Rester dans une même équipe sur une longue période m'a permis de comprendre les challenges qu'on peut rencontrer dans ce genre d'environnement et le lien fort entre dépassement de soi et problématique de groupe."
        },
        {
          nom: 'World of Warcraft',
          logo: 'WoW_logo.png',
          description: "Sur WoW, j'ai dirigé une guilde PvE HL, organisé des raids de plusieurs dizaines de personnes et participé à la gestion de communautés sur plusieurs serveurs."
          + "<br><br>L'expérience que j'ai eu sur WoW est pluridisciplinaire puisque il y a d'abord eu l'aspect relatif aux raids, c'est à de coordonner un groupe en moyenne de 20 personnes sur des actions à des timings précis."
          + "<br><br>L'autre aspect relatif au raid est la pédagogie nécessaire à une compréhension homogène de l'environnement dans lequel le groupe évolue."
          + "<br><br>Enfin, il y a l'aspect organisationnel sur lequel j'endossais le rôle d'analyste de logs, ce qui m'a permis de développer des compétences en analyse de données et en optimisation des performances."
        },
        {
          nom: 'Call of Duty',
          logo: 'CoD_logo.png',
          description: "J'ai participé à des compétitions sur Call of Duty, avec une expérience en teamplay, stratégie FPS et gestion de line-up. Cela a été ma première expérience esportive et ma première création de structure en 2013."
          + "<br><br>L'esport à ce moment n'était pas encore un concept établi et tout était à faire. En y rajoutant mon manque d'expérience et mon entêtement personnel, j'ai donc endossé le rôle de créateur de structure, manager et capitaine d'équipe."
          + "<br><br>Étant un jeu populaire, nous commencions à avoir plus de personnes intéressées pour rejoindre notre équipe et j'ai dû apprendre à gérer une line-up, des remplaçants et des essais de joueurs."
          + "<br><br>C'est donc à ce moment que j'ai endossé en plus de mes rôles précédents, celui de recruteur et coach pour ceux qui le souhaitaient."
          + "<br><br>A 15 ans, j'ai vite compris les problématiques humaines qui venaient s'ajouter au reste lorsque je passais mon temps à gérer autant mon équipe de 4 joueurs que les 3 autres équipes. Notre structure comptait alors une vingtaine de joueurs au total."
        }
      ],
      jeuSelectionne: null // Pour la modale
    };
  },
  methods: {
    navigateToMainPage() {
      this.$router.push({ name: 'MainPage' });
    },
    onLogoClick(jeu) {
      if (this.jeuSelectionne === jeu.nom) {
        this.jeuSelectionne = null;
      } else {
        this.jeuSelectionne = jeu.nom;
      }
    },
    fermerFenetre() {
      this.jeuSelectionne = null;
    },
    getImageForJeu(nom) {
      if (nom === 'League of Legends') return require('@/assets/LFT_cv.png');
      if (nom === 'Rocket League') return require('@/assets/logo_jeux/RL_logo.png');
      if (nom === 'World of Warcraft') return require('@/assets/logo_jeux/WoW_logo.png');
      if (nom === 'Call of Duty') return require('@/assets/logo_jeux/CoD_logo.png');
      return '';
    }
  }
}
</script>

<style scoped>

@keyframes dynamicBackground {
  0% { transform: scale(1); }
  50% { transform: scale(1.02); }
  100% { transform: scale(1); }
}

.esport-section {
  background-image: url("../assets/spaceman2.jpg");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  width: 100vw;
  height: 100vh;
  color: #eee;
  /*font-family: Arial, sans-serif;*/
  position: relative;
  overflow: hidden;
}

.esport-section::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: inherit;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 0;
  transform-origin: center;
  animation: dynamicBackground 10s ease-in-out infinite;
}

/* Isolation des éléments au-dessus du fond animé */
.esport-section > * {
  position: relative;
  z-index: 1;
}

.esport-logos-bottom {
  position: fixed;  /* <-- change absolute en fixed */
  left: 50%;
  bottom: 40px;
  transform: translateX(-50%);
  display: flex;
  gap: 2.5rem;
  z-index: 200;
}

.logo {
  position: absolute;
  transform: translate(-50%, -50%);
}

/* Positionnement stable en pixels relatifs à l’écran */
.logo-topleft {
  top: 30%;
  left: 30%;
}
.logo-bottomleft {
  bottom: 20%;
  left: 30%;
}
.logo-topright {
  top: 30%;
  right: 20%;
}
.logo-bottomright {
  bottom: 20%;
  right: 20%;
}

.esport-logo {
  pointer-events: auto;
  width: 110px;
  height: 110px;
  object-fit: contain;
  border-radius: 16px;
  background: rgba(0,0,0,0.25);
  box-shadow: 0 4px 16px rgba(0,0,0,0.18);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.esport-logo:hover {
  transform: scale(1.08);
  box-shadow: 0 8px 32px #FFD70099;
}

.back-button {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  z-index: 2;
}

.back-button:hover {
  background-color: #0056b3;
}

.back-button--img {
  background: #007bff; /* même bleu que ServicesPage */
  padding: 8px;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.12);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  color: #fff;
  transition: background 0.25s ease, transform 0.08s ease;
}

.back-button--img:hover {
  background-color: #0056b3; /* légère variation à l'hover */
  transform: translateY(-2px);
}

.back-button__img {
  width: 28px;
  height: 28px;
  object-fit: contain;
  display: inline-block;
}

/* accessibilité : texte caché pour lecteurs d'écran */
.visually-hidden {
  position: absolute !important;
  height: 1px; width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
}

/* Fenêtre modale */
.esport-modal {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(20, 20, 30, 0.1);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.2s;
  padding: 0;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.esport-modal-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 2rem;
  min-height: 48px;
}

.esport-modal-title {
  flex: 1;
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
  margin: 0;
  color: #FFD700;
  z-index: 1;
  pointer-events: none;
  line-height: 1.2;
  padding-right: 2.5rem;
}

.modal-close-btn {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: #FFD700;
  color: #1e293b;
  border: none;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
  z-index: 2;
  pointer-events: auto;
}

.modal-close-btn:hover {
  background: #fffbe7;
}

@media (max-width: 900px) {
  .esport-modal-header {
    min-height: 36px;
    margin-bottom: 1.2rem;
  }
  .esport-modal-title {
    font-size: 1.2rem;
    padding-right: 2rem;
  }
  .modal-close-btn {
    width: 32px;
    height: 32px;
    font-size: 1.1rem;
  }
}

.esport-modal-content {
  background: #1e293b;
  border-radius: 18px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.35);
  padding: 4.5rem 2.5rem 2.5rem 2.5rem;
  min-width: 60vw;
  max-width: 90vw;
  max-height: calc(100vh - 200px);
  color: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 300;
  overflow: hidden; /* <-- change overflow-y: auto en overflow: hidden */
  user-select: none;
}

@media (max-width: 900px) {
  .esport-modal-content {
    min-width: 90vw;
    max-width: 90vw;
    padding: 1.5rem 0.5rem 1.5rem 0.5rem;
    max-height: calc(100vh - 180px);
    overflow-y: auto;
    touch-action: pan-y; /* allow vertical touch scrolling on mobile */
  }

  .lol-modal-flex {
    flex-direction: column;
    align-items: center;
    gap: 1.2rem;
  }

  .lol-modal-img {
    width: 90vw;
    max-width: 95vw;
  }

  .lol-modal-texte {
    width: 100%;
    font-size: 1rem;
    text-align: center;
  }
}

/* MODALE LOL STYLES */
.lol-modal-flex {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 2.5rem;
  width: 100%;
  margin-bottom: 2rem;
  user-select: none;
  /* touch-action removed to allow vertical touch scrolling */
}

.lol-modal-img {
  max-width: 40vw;
  border-radius: 16px;
  box-shadow: 0 4px 24px #0008;
  background: #222;
  user-select: none;
  pointer-events: none;
}

.lol-modal-texte {
  flex: 1;
  font-size: 1.15rem;
  color: #fff;
  display: flex;
  align-items: center;
  min-width: 0;
  word-break: break-word;
  user-select: none;
  /* touch-action removed to allow vertical touch scrolling */
}

.lol-modal-bottom {
  width: 100%;
  margin-top: 1.5rem;
  font-size: 1.08rem;
  color: #FFD700;
  background: rgba(30,41,59,0.7);
  border-radius: 8px;
  padding: 1.2rem 1rem;
  text-align: center;
  user-select: none;
  touch-action: none;
}

/* Modale autres jeux */
.othergame-modal-text {
  width: 100%;
  min-height: 220px;
  font-size: 1.18rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2.5rem 1.5rem;
  user-select: none;
  /* touch-action removed to allow vertical touch scrolling */
}

/* Responsive */
@media (max-width: 900px) {
  .esport-logo {
    width: 70px;
    height: 70px;
  }
  .esport-logos-bottom {
    gap: 1.2rem;
    bottom: 20px;
  }
  .logo-topleft {
    top: 30%;
    left: 30%;
  }
  .logo-bottomleft {
    bottom: 30%;
    left: 30%;
  }
  .logo-topright {
    top: 30%;
    right: 30%;
  }
  .logo-bottomright {
    bottom: 30%;
    right: 30%;
  }
  .esport-modal-content {
    min-width: 90vw;
    max-width: 90vw;
    padding: 1.5rem 0.5rem 1.5rem 0.5rem; /* Ajoute un padding-top équivalent au desktop */
    max-height: calc(100vh - 180px);
  }
  .lol-modal-flex {
    flex-direction: column;
    align-items: center;
    gap: 1.2rem;
  }
  .lol-modal-img {
    width: 90vw;
    max-width: 95vw;
  }
  .lol-modal-texte {
    width: 100%;
    font-size: 1rem;
    text-align: center;
  }
}

</style>